/**
 * Copyright (c) 2026 上海安能聚创供应链管理有限公司.
 * All rights reserved.
 * 公司内部代码，未经书面授权，不得以任何形式复制、传播或用于与本项目无关的其他用途.
 */
import * as Sentry from '@sentry/react';

/* global CUSTOM_ENV, SENTRY_ENABLE_DEV, SENTRY_RELEASE */

// 全项目唯一 dsn：来自 Sentry 项目 route-forecast-ui（org: sentry）的 Default key
const sentryDsn = 'https://e59c7f08f5d940f719d7c891960796de@sentry-ingest.ane56.com/58';
// 环境标识：优先用构建注入的 CUSTOM_ENV，其次按 NODE_ENV 推断
const sentryEnv =
  typeof CUSTOM_ENV === 'string'
    ? CUSTOM_ENV
    : process.env.NODE_ENV === 'production'
    ? 'prod'
    : 'dev';
// release：必须与构建上传 release 一致
const sentryRelease = typeof SENTRY_RELEASE === 'string' ? SENTRY_RELEASE : '';
const enableDev = typeof SENTRY_ENABLE_DEV === 'boolean' ? SENTRY_ENABLE_DEV : false;
// prod/test 构建包默认开启；本地 dev 需要显式 SENTRY_ENABLE_DEV 才开启
const sentryEnabled =
  sentryEnv === 'prod' || sentryEnv === 'test' || (sentryEnv === 'dev' && enableDev);

let initialized = false;

/**
 * 初始化 Sentry：幂等，dsn 未回填或当前环境不启用时直接跳过
 */
export function initSentry() {
  if (initialized || !sentryEnabled || !sentryDsn) {
    return;
  }

  try {
    Sentry.init({
      dsn: sentryDsn,
      environment: sentryEnv,
      release: sentryRelease,
      integrations: (integrations) =>
        integrations.filter(
          (integration) =>
            !String(integration.name || '')
              .toLowerCase()
              .includes('replay'),
        ),
      // 默认关闭高成本能力；需要性能监控时再评估打开
      tracesSampleRate: 0,
      autoSessionTracking: false,
    });

    initialized = true;
  } catch (_error) {}
}
